import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  errorMsg: FelaCSS;
  uploadWrapper: FelaCSS;
  infoText: FelaCSS;
  formField: FelaCSS;
  captchaWrapper: FelaCSS;
  photoWrapper: FelaCSS;
  header: FelaCSS;
  detailsForm: FelaCSS;
  submitWrapper: FelaCSS;
}

export const styles: IStyles = {
  wrapper: {
    backgroundColor: colors.white,
    gap: '20px',
    padding: 4,
    maxWidth: 700,
    width: '100%',

    minWidthTabletLg: {
      gap: '32px',
    },
  },
  errorMsg: {
    fontDefaultSemiBold: 14,
    color: colors.alerts,
  },
  uploadWrapper: {
    flexDirection: 'column',
    height: '100%',
    gap: '12px',
  },
  infoText: {
    fontDefaultItalic: 14,
    textAlign: 'center',
    color: colors.space75,
  },
  formField: {
    gap: '12px',
  },
  captchaWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  photoWrapper: {
    borderRadius: 16,
    overflow: 'hidden',
  },
  header: {
    width: '100%',
    borderBottom: `1px solid ${colors.space15}`,
    alignItems: 'center',
    justifyContent: 'center',
    height: 80,
  },
  detailsForm: {
    gap: '20px',

    minWidthTabletLg: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: 'auto auto',
    },
  },
  submitWrapper: {
    minWidthTabletLg: {
      paddingHorizontal: '30%',
      paddingVertical: 5,
    },
  },
};
